/**
 * MapLibre with PMTiles.
 *
 * Spec §10: the territorial pipeline uploads a PMTiles archive to the `tiles`
 * bucket and the SPA reads it through CloudFront with the PMTiles protocol.
 * **No tile server runs** — that is the entire point of the format choice, and
 * it is why the tiles path is the one exception to "the SPA talks only to the
 * API".
 */

import { addProtocol, setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';
import { Protocol } from 'pmtiles';

let registered = false;

/**
 * Register the `pmtiles://` protocol with MapLibre. Idempotent: MapLibre keeps
 * one global protocol registry, so registering twice would replace the handler.
 */
export function registerPmtilesProtocol(): void {
  if (registered) {
    return;
  }
  const protocol = new Protocol();
  addProtocol('pmtiles', protocol.tile);
  registered = true;
}

/**
 * Point MapLibre at its own worker script. MapLibre starts the worker from a
 * URL it derives from the chunk that constructs the map, and the bundler emits
 * no worker beside that chunk, so a map built without this stalls every tile
 * request and raises nothing: the screen reads as an archive that never loads.
 * Setting the URL is idempotent, so this needs no once-guard.
 */
export function registerMapWorker(): void {
  setWorkerUrl(workerUrl);
}

export function pmtilesSourceUrl(archiveUrl: string): string {
  return `pmtiles://${archiveUrl}`;
}
